export { SecuritiesPage as default } from '@/components/enpages/Ir/Library/Securities'
